import React, { useEffect, useState } from 'react';
import { Wrapper } from './styled';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Layout from '../Layout';
import Header from '../Header';
import { useParams } from 'react-router-dom';
import CryptoJS from 'crypto-js';
import { GetUserOther } from '../../service/user';
import html2canvas from 'html2canvas';
import IOS from '../Popup';
import Android from '../Android';

const BusinessCard = ({
	children,
	active,
	toggle,
	widht,
	height,
	maxHeight,
	padding,
	home,
	auto,
	display,
	user,
}) => {
	const [agent, setAgent] = useState('');
	useEffect(() => {
		const userAgent = navigator.userAgent;

		const isKakaoTalkInAppBrowser = /KAKAOTALK/i.test(navigator.userAgent);

		if (isKakaoTalkInAppBrowser) {
			console.log('카카오톡 인앱에서 실행 중입니다.');
			if (userAgent.match(/Android/i)) {
				console.log('안드로이드 기기에서 실행 중입니다.');
				// 여기에 필요한 동작을 추가하세요.
				setAgent('android');
			} else if (userAgent.match(/iPhone/i) || userAgent.match(/iPad/i)) {
				console.log('iOS 기기에서 실행 중입니다.');
				setAgent('ios');
				// 여기에 필요한 동작을 추가하세요.
			} else {
				console.log('다른 운영체제에서 실행 중입니다.');
				// 다른 운영체제에서 실행 중인 경우에 대한 처리를 추가하세요.
			}
		} else {
			console.log('not kakao');
			setAgent('');
		}
	}, []);

	const [isOpen, setIsOpen] = useState(active ? true : false);
	const [isOpen2, setIsOpen2] = useState(active ? true : false);
	const [isActive, setIsActive] = useState(active ? true : false);
	const [isUserImageVisible, setIsUserImageVisible] = useState(
		active ? true : false
	);
	// const active = 1;
	const params = useParams();
	// const user_id = params.id;

	const params_ = new URLSearchParams(window.location.search);
	let user_id = params.id ? params.id : params_.get('author');

	const [p, setP] = useState(false);

	const [userData, setUser] = useState();
	// const [decryptedNumber, setDecryptedNumber] = useState('');
	// const decryptData = () => {
	// 	if (user_id) {
	// 		const key = 'dnjdlek'; // Replace with your own secret key
	// 		const decrypted = CryptoJS.AES.decrypt(user_id, key).toString(
	// 			CryptoJS.enc.Utf8
	// 		);
	// 		setDecryptedNumber(decrypted);
	// 	}
	// };

	// useEffect(() => {
	// 	if (user_id) {
	// 		decryptData();
	// 	}
	// }, [user_id]);

	const toggleDropdown = () => {
		setIsOpen(!isOpen);
		setIsActive(!isActive);
		setIsUserImageVisible((p) => !p);
	};

	const qrToggle = () => {
		setIsOpen2(!isOpen2);
	};

	const [isOther, setOther] = useState(true);
	const [activeTab, setActiveTab] = useState('1');

	const TabClick = (tab) => {
		setActiveTab(tab);
	};

	const taglist = [
		{
			tag: 'IT품질관리자',
		},
		{
			tag: '신입사원',
		},
		{
			tag: '관리',
		},
		{
			tag: '관리',
		},
	];

	const settings = {
		arrows: false,
		dots: true,
		infinite: false,
		speed: 500,
		slidesToShow: 1,
		// centerMode: true,
	};

	const saveNumber = () => {
		var contact = {
			name: userData?.user_name,
			phone: userData?.user_phone,
			email: userData?.user_email,
		};
		// '\nTEL;TYPE=work,voice:' +

		var vcard =
			`BEGIN:VCARD\r\n` +
			`VERSION:3.0\r\n` +
			`FN;CHARSET=UTF-8:${contact.name}\r\n` +
			`TEL;voice:${contact.phone}\r\n` +
			`EMAIL:${contact.email}\r\n` +
			`END:VCARD`;
		var blob = new Blob([vcard], { type: 'text/vcard;charset=utf-8' });
		var url = URL.createObjectURL(blob);

		const newLink = document.createElement('a');
		newLink.download = contact.name + '.vcf';
		newLink.textContent = contact.name;
		newLink.href = url;

		newLink.click();
	};

	const saveAsImage = () => {
		html2canvas(document.getElementById('saveimg')).then(function (canvas) {
			var link = document.createElement('a');
			link.href = canvas.toDataURL('image/png');
			link.download = '전자명함.png';
			link.click();

			// const imageDataURL = canvas.toDataURL('image/png');

			// // Open a new window or tab with the image URL
			// const newWindow = window.open();
			// newWindow.document.write('<img src="' + imageDataURL + '" />');
		});

		// const imageDataURL = canvas.toDataURL('image/png');

		// // Open a new window or tab with the image URL
		// const newWindow = window.open();
		// newWindow.document.write('<img src="' + imageDataURL + '" />');
	};

	useEffect(() => {
		if (user_id && !params_.get('author')) {
			GetUserOther({
				user_id: user_id,
			})
				.then((response) => {
					console.log(response.data.body);
					if (response.data.code == 200) {
						setUser(response.data.body);
					}
					setP(true);
				})
				.catch((err) => {
					setP(true);
					console.log(err);
				});
		}
	}, [user_id]);

	useEffect(() => {
		if (params_.get('author')) {
			GetUserOther({
				user_id: params_.get('author'),
			})
				.then((response) => {
					console.log(response.data.body);
					if (response.data.code == 200) {
						setUser(response.data.body);
					}
					setP(true);
				})
				.catch((err) => {
					setP(true);
					console.log(err);
				});
		}
	}, [params_.get('author')]);

	// useEffect(() => {
	// 	if (user_id) {
	// 		decryptData();
	// 	}
	// }, [user_id]);

	if (agent == 'ios') {
		return <IOS />;
	}

	if (agent == 'android') {
		return <Android />;
	}

	return (
		<Wrapper
			active={active}
			width={widht}
			height={height}
			maxHeight={maxHeight}
			auto={auto}
			padding={padding}
			home={home}
		>
			<div className={`container ${isOpen ? 'open' : ''}`}>
				{isUserImageVisible && (
					<div className={`modal-wrap ${isOpen ? 'open' : ''}`}>
						<div className="top">
							<div className="tit-box">
								{params.id ? (
									<i
										// onClickCapture={() => window.history.back()}
										className="back"
										onClick={() => window.close()}
										// onClick={() => window.close()}
									>
										<img
											src={
												1
													? '/images/icon-closebtn02.svg'
													: '/images/icon-back03.svg'
											}
											alt=""
										/>
									</i>
								) : (
									<i
										// onClickCapture={() => window.history.back()}
										className="back"
										onClick={toggleDropdown}
										// onClick={() => window.close()}
									>
										<img
											src={
												1
													? '/images/icon-closebtn02.svg'
													: '/images/icon-back03.svg'
											}
											alt=""
										/>
									</i>
								)}

								<h2>전자명함</h2>
							</div>
							<div className="share-btn">
								{/* <img src="/images/icon-share.svg" alt="" /> */}
							</div>
						</div>
						<div className="name-card-wrapper">
							<Slider {...settings}>
								<div id="user-box" className="user-box">
									<div id="saveimg" className="saveimg">
										<div className="logo">
											<img src="/images/kb-logo.png" alt="" />
										</div>
										<div className="name-box">
											<h1>{userData?.user_name}</h1>
											<div className="position">
												<p className="department">
													{userData?.user_department}
												</p>
												<p>{userData?.position}</p>
											</div>
											<div className="address-box">
												<p className="address">{userData?.address}</p>
												<div className="flex">
													<h6>E</h6>
													<p>{userData?.user_email}</p>
												</div>
												<div className="tell">
													<div className="flex">
														<h6>T</h6>
														<p>{userData?.tel}</p>
													</div>
													<div className="flex">
														<h6>F</h6>
														<p>{userData?.fax}</p>
													</div>
												</div>
												<div className="flex flex2">
													<h6>M</h6>
													<p>{userData?.user_phone}</p>
												</div>
											</div>
										</div>
									</div>
								</div>

								<div className="career-box">
									<div className="career-inner">
										<div className="top-menu">
											<img src="/images/icon-comment.svg" alt="" />
											<p>경력 사항</p>
										</div>
										<div className="user-info">
											<div className="txt">
												<h2>{userData?.card_intro}</h2>
												<h3>
													{userData?.user_name}
													{userData?.position ? ` ${userData?.position}` : null}
													입니다.
												</h3>
											</div>
											<div
												className="user"
												style={{
													backgroundImage: `url(${userData?.user_avatar_url_original})`,
												}}
											></div>
										</div>
										<div className="detail">
											<h3>{userData?.profile}</h3>
											<p>
												{userData?.sub_career1}
												<br />
												{userData?.sub_career2}
												<br />
												{userData?.sub_career3}
											</p>
										</div>
										<div className="tag-list">
											{userData?.user_tag?.length
												? userData?.user_tag.map((item, key) => (
														<>
															<div className="tag" key={key}>
																# {item}
															</div>
														</>
												  ))
												: null}
										</div>
										{userData?.post_link ? (
											<div className="share-box">
												<a href={userData?.post_link} className="share">
													<img src="/images/icon-share02.svg" alt="" />
													<span>{userData?.post_title}</span>
												</a>
											</div>
										) : null}
									</div>
									{/* <a
										href={`https://wp.daitso.kbds.co.kr/wp-admin/user-edit.php?user_id=${userData?.ID}`}
										className="pen"
									>
										<img src="/images/icon-pen.svg" alt="" />
									</a> */}
								</div>
							</Slider>
						</div>
					</div>
				)}

				{isUserImageVisible ? (
					<div className="inner">
						<div
							className={`toggle ${isOpen ? 'open' : ''}`}
							// onClick={toggleDropdown}
						>
							<div className="cont">
								<div className="top">
									<div onClick={saveNumber} className="address-book">
										<img src="/images/icon-addressbook.svg" alt="" />
										<h2>주소록 추가</h2>
									</div>
									<div className="bar"></div>
									<div onClick={saveAsImage} className="img-box">
										<img src="/images/icon-down03.svg" alt="" />
										<h4>이미지 저장</h4>
									</div>
								</div>
							</div>
						</div>
					</div>
				) : (
					<div className="inner2">
						<div
							className={`toggle ${isOpen ? 'open' : ''}`}
							onClick={toggleDropdown}
						>
							<div className="cont cont2">
								<div className="top">
									<div className="name-box">
										<div
											className="userimg"
											style={{
												backgroundImage: `url(${userData?.user_avatar_url_original})`,
											}}
										></div>
										<h2>{userData?.user_name}</h2>
									</div>
									<div className="arrow-box">
										<h4>전자명함 보기</h4>
										<img src="/images/arrow-top.svg" alt="" />
									</div>
								</div>
							</div>
						</div>
					</div>
				)}
			</div>
		</Wrapper>
	);
};

export default BusinessCard;
